module.exports = __webpack_public_path__ + "media/images/soar/site/highlight_03-28f926cd2e4f5eba07356b2e583dd561.svg";